import React from "react";
import styles from "./DotLoadingComponent.module.scss";

type DotLoadingComponentProps = {
    size?: number;
    color?: string;
};

const DotLoadingComponent: React.FC<DotLoadingComponentProps> = ({ size = 6, color = "#adb5bd" }) => {
    return (
        <div
            className={styles.wrapper}
            style={
                {
                    "--dot-size": `${size}px`,
                    "--dot-color": color,
                } as React.CSSProperties
            }
        >
            <span className={styles.dot} />
            <span className={styles.dot} />
            <span className={styles.dot} />
        </div>
    );
};

export default DotLoadingComponent;
